import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import { RetellWebClient } from "retell-client-js-sdk";
import MessageList from './components/MessageList';
import CongratulationScreen from './components/CongratulationScreen';

import junoListen from "./assets/juno-image.png";

const apiKey = process.env.REACT_APP_RETELL_API_KEY;
const agentId = process.env.REACT_APP_RETELL_AGENT_ID;

const retellWebClient = new RetellWebClient();

async function fetchCreateCallResponse() {
  const url = 'https://api.retellai.com/v2/create-web-call';
  
  try {
    const response = await axios.post(url, {
      agent_id: agentId
    }, {
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log('Web call created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating web call:', error);
    throw error; // Rethrow the error so it can be caught in handleRecord
  }
}

const App = () => {
  const [points, setPoints] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [messages, setMessages] = useState([]);
  const [showCongratulations, setShowCongratulations] = useState(false);
  const [hasMicAccess, setHasMicAccess] = useState(false);
  
  const requestMicrophoneAccess = async () => {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        console.error("getUserMedia is not supported in this browser");
        return false;
      }
  
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setHasMicAccess(true);
      return stream;
    } catch (err) {
      console.error("Error accessing microphone:", err);
      setHasMicAccess(false);
      return false;
    }
  };
  
  const handleRecord = async () => {
    const audioStream = await requestMicrophoneAccess();
    if (!audioStream) {
      alert("Microphone access is required to record audio.");
      return;
    }

    setIsRecording(true);
    try {
      const webCallResponse = await fetchCreateCallResponse();

      // console.log("Access token: ", webCallResponse.access_token);
      await retellWebClient.startCall({
        accessToken: webCallResponse.access_token,
      });

      // Update message such as transcript
      retellWebClient.on("update", (update) => {
        // console.log("Update:", update);
        setMessages(update.transcript)
        const userMessageCount = update.transcript.filter(message => message.role === 'user').length;
        setPoints(userMessageCount);    
      });

    } catch (error) {
      console.error('Error starting call:', error);
      setIsRecording(false);
    }
  };

  const handleEnd = () => {
    setIsRecording(false);
    retellWebClient.stopCall();

    // Stop all audio tracks
    navigator.mediaDevices.getUserMedia({ audio: true })
    .then(stream => {
      stream.getTracks().forEach(track => track.stop());
    });

    setShowCongratulations(true);
    
    // Show congratulations screen for 5 seconds
    setTimeout(() => {
      setShowCongratulations(false);
      setPoints(0); // Reset points for next session
    }, 5000);
  };

  return (
    <div className="juno-app">
      {showCongratulations ? (
        <CongratulationScreen points={points} />
      ) : (
      <>
      <h1>Juno</h1>
      <div className="points-display">
        {points === 0 ? (
          <>
            <span>Speak to get more stars</span>
            <span className="star">⭐</span>
          </>
        ) : (
          <>
            <div>
              <span className="star">{'⭐'.repeat(points)}</span>
            </div>
            <div>
              <span>You got </span>
              <span style={{fontWeight: 'bold'}}>{points}</span>
              <span> stars</span>
            </div>
          </>
        )}
      </div>
      <div className="content-area">
        <div className="transcript">
          <MessageList messages={messages || []}/>
        </div>
        <img src={junoListen} alt="Cute elephant" className="mascot" />
      </div>
      <button 
        className={`record-button ${isRecording ? 'recording' : ''}`} 
        onClick={handleRecord}
        disabled={!hasMicAccess && isRecording}
      >
        {hasMicAccess ? (isRecording ? 'Recording...' : 'Start') : 'Allow Mic Access'}
      </button>
      <button className="end-button" onClick={handleEnd}>
        End
      </button>
    </>
    )}
    </div>
  );
};

export default App;